import React from 'react';
import { Container, Carousel } from 'react-bootstrap';

function Header() {
  
  const images = [
    { src: "/images/Foto28.jpeg", alt: "Autobotte Nucifora Trasporti rifornisce una piscina privata - servizio fornitura acqua in Sicilia" },
    { src: "/images/Foto5.jpeg",  alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero - trasporti nazionali Italia" },
    { src: "/images/Foto18.jpeg", alt: "Iveco EuroCargo Nucifora Trasporti con cisterna per trasporto acqua - Sant'Alfio Catania" },
    { src: "/images/Foto12.jpeg", alt: "Iveco EuroCargo Nucifora Trasporti con furgonato in consegna tra i vigneti siciliani" },
  ];

  return (
    <><Container fluid className="mt-4">
      <Carousel fade interval={3000} className="mt-4">
        {images.map((img, index) => (
          <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={img.src}
              alt={img.alt}
              style={{ width: '100%', maxHeight: '500px', objectFit: 'cover' }} />
          </Carousel.Item>
        ))}
      </Carousel>
    </Container><div className="w3-container" style={{ marginTop: "80px" }} id="showcase">
        <h1 className="w3-jumbo"><b>Nucifora Trasporti </b></h1>
        <p className="w3-large w3-text-amber" style={{ marginTop: '-10px', marginBottom: '20px' }}>
          <i><b>Il cuore del trasporto</b></i>
        </p>
        <hr className="w3-round hr-amber" />
        <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>L’amore per il nostro lavoro è il motore che da sempre guida <b>Nucifora Trasporti</b>.
          Fondata su solidi pilastri di eccellenza e affidabilità,questi valori, uniti a un incessante
          dedizione, ci permettono di portare avanti il nostro lavoro quotidiano.  </p>
        <img
          src={"/images/Locandina.jpeg"}
          alt="Locandina Nucifora Trasporti"
          style={{
            width: "100%",
            objectFit: "cover",
            borderRadius: "12px",
            marginBottom: "20px"
          }} />
      </div></>
  );
}

export default Header;
